import * as React from "react";
import cx from "classnames";
import styles from "./index.module.css";

interface IProps {
  className?: string;
  onSearch: (value: string) => void;
  placeholder?: string;
}

function Search({
  className = "",
  onSearch,
  placeholder = "Search by name or email"
}: IProps) {
  const [value, setValue] = React.useState("");

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(value);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (e.target.value === "") {
      onSearch(e.target.value);
    }
  };

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <input
        className={cx(styles.input, { [className]: className })}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </form>
  );
}

export default Search;
